import { constants } from '@yola/subscription-manager-js';
import { t } from '../../localization';
import formatPrice from './format-price';
import configStorage from '../../configuration/config-storage';

const { MONTHLY } = constants.SubscriptionTerm;

const getSpecialOfferCaptions = ({
  discount: discountAmount,
  activeSubscriptionTerm,
  canGetDomainForFree,
  currency,
}) => {
  const { locale = 'en' } = configStorage.get();

  const discount = formatPrice(discountAmount, currency, locale);
  const title = t('Get a FREE domain with Annual Plan');
  const tagTitle = t('special offer');

  if (canGetDomainForFree) {
    return {
      title: t('Claim your next domain for free'),
      tagTitle: t('special gift'),
      description: t(
        'Enjoy {discount} off your first year’s domain with your existing annual plan',
        { discount }
      ),
    };
  }

  if (activeSubscriptionTerm === MONTHLY) {
    return {
      title,
      tagTitle,
      description: t(
        'Enjoy {discount} off your first year’s domain when you upgrade to an annual plan',
        { discount }
      ),
    };
  }

  return {
    title,
    tagTitle,
    description: t('Enjoy {discount} off your first year’s domain when you select an annual plan', {
      discount,
    }),
  };
};

export default getSpecialOfferCaptions;
